import React, { Component } from 'react';
import styles from './QuizCreator.module.css';
import Button from '../../components/UI/Button';
import Input from '../../components/UI/Input';
import Select from '../../components/UI/Select';
import { createControl, validate, validateForm } from '../../form/formFramework';
import Auxiliary from '../../hoc/Auxiliary';
import { createQuizQuestion, finishCreateQuiz, createQuizErrorRemove } from '../../store/actions/create';
import { connect } from 'react-redux';
import { arrayOf, shape, string, number, func } from 'prop-types';
import nextId from 'react-id-generator';

const createOptionControl = (number) => {
  return createControl({
    label: `Вариант ${number}`,
    errorMessage: 'Значение не может быть пустым',
    id: number
  }, { required: true })
}

const createFormControls = () => {
  return {
    question: createControl({
      label: 'Введите вопрос',
      errorMessage: 'Вопрос не может быть пустым'
    }, { required: true }),
    option1: createOptionControl(1),
    option2: createOptionControl(2),
    option3: createOptionControl(3),
    option4: createOptionControl(4)
  }
}

class QuizCreator extends Component {

  static propTypes = {
    quiz: arrayOf(shape({
      question: string,
      id: number.isRequired,
      rightAnswerId: number.isRequired,
      answers: arrayOf(shape({
        text: string,
        id: number.isRequired,
      }))
    })),

    createQuizQuestion: func,
    finishCreateQuiz: func,
  }

  static defaultProps = {
    quiz: arrayOf(shape({
      question: '',
      id: nextId(),
      rightAnswerId: '',
      answers: arrayOf(shape({
        text: '',
        id: nextId(),
      }))
    })),

    createQuizQuestion: () => { },
    finishCreateQuiz: () => { },
  }

  state = {
    quiz: [],
    isFormValid: false,
    rightAnswerId: 1,
    formControls: createFormControls()
  }

  componentWillUnmount() {
    const { error, createQuizErrorRemove } = this.props

    if (error) {
      createQuizErrorRemove()
    }
  }

  submitHandler = event => event.preventDefault()

  addQuestionHandler = event => {
    const { rightAnswerId, formControls: { question: { value }, option1, option2, option3, option4 } } = this.state
    const { quiz, createQuizQuestion } = this.props

    event.preventDefault()

    const questionItem = {
      question: value,
      id: quiz.length + 1,
      rightAnswerId,
      answers: [
        { text: option1.value, id: option1.id },
        { text: option2.value, id: option2.id },
        { text: option3.value, id: option3.id },
        { text: option4.value, id: option4.id }
      ],
    }

    createQuizQuestion(questionItem)

    this.setState({
      isFormValid: false,
      rightAnswerId: 1,
      formControls: createFormControls()
    })
  }

  createQuizHandler = event => {
    const { finishCreateQuiz } = this.props
    event.preventDefault()

    this.setState({
      quiz: [],
      isFormValid: false,
      rightAnswerId: 1,
      formControls: createFormControls()
    })
    finishCreateQuiz()
  }

  changeHandler = (value, controlName) => {
    const formControls = { ...this.state.formControls }
    const control = { ...formControls[controlName] }
    const { error, createQuizErrorRemove } = this.props

    control.touched = true
    control.value = value
    control.valid = validate(control.value, control.validation)

    formControls[controlName] = control

    this.setState({
      formControls,
      isFormValid: validateForm(formControls)
    })

    if (error) {
      createQuizErrorRemove()
    }
  }

  renderControls() {
    const { formControls } = this.state

    return Object.keys(formControls).map((controlName, index) => {
      const control = formControls[controlName]
      const { label, value, valid, validation, touched, errorMessage } = control

      return (
        <Auxiliary key={controlName + index}>
          <Input
            label={label}
            value={value}
            valid={valid}
            shouldValidate={!!validation}
            touched={touched}
            errorMessage={errorMessage}
            onChange={({ target: { value } }) => this.changeHandler(value, controlName)}
          />
          {!index && <hr />}
        </Auxiliary>
      )
    })
  }

  selectChangeHandler = ({ target: { value } }) => {
    this.setState({ rightAnswerId: +value })
  }

  render() {
    const { quiz, error } = this.props
    const { isFormValid, rightAnswerId } = this.state

    const select =
      <Select
        label="Выберите правильный ответ"
        value={rightAnswerId}
        onChange={this.selectChangeHandler}
        options={[
          { text: 1, value: 1 },
          { text: 2, value: 2 },
          { text: 3, value: 3 },
          { text: 4, value: 4 }
        ]}
      />

    return (
      <div className={styles.quizCreator}>
        <div>
          <h1>Создание теста</h1>

          <form onSubmit={this.submitHandler}>

            {this.renderControls()}

            {select}
            <Button
              type="primary"
              onClick={this.addQuestionHandler}
              disabled={!isFormValid}
            >
              Добавить вопрос
            </Button>

            <Button
              type="success"
              onClick={this.createQuizHandler}
              disabled={!quiz.length}
            >
              Создать тест
            </Button>

            {error && <p className={styles.error}>Во время создания теста произошла ошибка.</p>}
          </form>
        </div>
      </div>
    )
  }
}

export default connect(({ create: { quiz, error } }) => ({
  quiz, error
}), { createQuizQuestion, finishCreateQuiz, createQuizErrorRemove })(QuizCreator)